import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isEmpty } from 'helpers/verify';
import { DefineVariables } from 'providers/ContextVariables';
import { CallToAction, ACTIONS } from 'components/CallToAction';
import { ProductCard } from './cards/ProductCard';
import { SignupCard } from './cards/SignupCard';
export var ProductGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductGroup, _Component);

  function ProductGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProductGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProductGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.CARD_RENDERER_BY_TYPE = {
      productcard: _this.renderProductCard.bind(_assertThisInitialized(_this)),
      signupcard: _this.renderSignupCard.bind(_assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(ProductGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.msaId !== prevProps.msaId) {
        this.props.loadCardData({
          productType: this.props.productType,
          productCode: this.props.productCode
        });
      }
    }
  }, {
    key: "selectCardRenderer",
    value: function selectCardRenderer(type) {
      var normalizedType = (type || '').toLowerCase();
      return this.CARD_RENDERER_BY_TYPE[normalizedType] || this.CARD_RENDERER_BY_TYPE.productcard;
    }
  }, {
    key: "renderProductCard",
    value: function renderProductCard() {
      var _this$props = this.props,
          card = _this$props.card,
          cmsModuleId = _this$props.cmsModuleId;

      var _ref = card || {},
          ctaCopy = _ref.ctaCopy,
          url = _ref.url;

      var cta = ctaCopy && url && React.createElement(CallToAction, {
        action: ACTIONS.LINK,
        color: "primary_solid",
        extraClass: "bt--lg bt--width-full",
        to: url
      }, ctaCopy);
      return React.createElement(ProductCard, _extends({}, card, {
        cta: cta,
        cmsModuleId: cmsModuleId
      }));
    }
  }, {
    key: "renderSignupCard",
    value: function renderSignupCard() {
      var _this$props2 = this.props,
          card = _this$props2.card,
          cmsModuleId = _this$props2.cmsModuleId;
      return React.createElement(SignupCard, _extends({}, card, {
        cmsModuleId: cmsModuleId
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          card = _this$props3.card,
          cardType = _this$props3.cardType,
          disclaimer = _this$props3.disclaimer,
          msaId = _this$props3.msaId;

      if (isEmpty(card)) {
        return null;
      }

      var Card = this.selectCardRenderer(cardType);
      return React.createElement("div", {
        className: "ProductGroup"
      }, React.createElement("div", {
        className: "ProductGroup__cards"
      }, React.createElement(DefineVariables, {
        variables: card.contextVariables
      }, React.createElement(Card, {
        key: msaId
      }))), disclaimer && React.createElement("p", {
        className: "ProductGroup__disclaimer"
      }, disclaimer));
    }
  }]);

  return ProductGroup;
}(Component);
ProductGroup.propTypes = {
  card: PropTypes.object,
  cardType: PropTypes.string,
  cmsModuleId: PropTypes.string.isRequired,
  disclaimer: PropTypes.node,
  loadCardData: PropTypes.func.isRequired,
  hasEmbeddedSignup: PropTypes.bool,
  msaId: PropTypes.number,
  productCode: PropTypes.string,
  productType: PropTypes.string
};